export function requiresUserRuleBookSelection(
  billingRun,
  isClearingSale,
  defaultRuleBookId,
) {
  if (!isClearingSale || !billingRun?.id) {
    return false;
  }
  // Returns true if the Clearing Sale billing run is on the system default rule book
  // or no system default rule book exists for this clearing sale's sub-type.
  return !defaultRuleBookId || billingRun.ruleBookId === defaultRuleBookId;
}
